import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import VideoCard from '@/components/feature/VideoCard';
import { categories, videoData } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];

  const filteredVideos = videoData.filter((v) => v.category === currentCategory.slug);

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: `${currentCategory.name} - 小蓝视频`,
          description: currentCategory.description,
          url: `https://kbhkgkg.cn/category/${currentCategory.slug}`,
          isPartOf: {
            '@type': 'WebSite',
            name: '小蓝视频',
            url: 'https://kbhkgkg.cn',
          },
        })}
      </script>
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '分类浏览' },
              { label: currentCategory.name },
            ]}
          />

          <div className="mb-10">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className={`${currentCategory.icon} text-accent-600 text-lg`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                {currentCategory.name}
              </h1>
            </div>
            <p className="text-sm text-foreground-500 ml-13">{currentCategory.description}</p>
          </div>

          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  cat.slug === currentCategory.slug
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredVideos.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {filteredVideos.map((video) => (
                <VideoCard
                  key={video.id}
                  id={video.id}
                  title={video.title}
                  coverImage={video.coverImage}
                  duration={video.duration}
                  views={video.views}
                  author={video.author}
                  authorAvatar={video.authorAvatar}
                  category={video.category}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mx-auto mb-4">
                <i className="ri-video-line text-foreground-400 text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}